import { render, staticRenderFns } from "./smartScreenSetting.vue?vue&type=template&id=d391166a&scoped=true&"
import script from "./smartScreenSetting.vue?vue&type=script&lang=ts&"
export * from "./smartScreenSetting.vue?vue&type=script&lang=ts&"
import style0 from "./smartScreenSetting.vue?vue&type=style&index=0&id=d391166a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d391166a",
  null
  
)

export default component.exports